// MWA-362 — where Back goes when there is no in-app page to return to: a link
// opened in a new tab, a bookmark, a reload of the first page visited. One level
// up the record the page belongs to, else the shell's home. Null on home itself.
export function backFallbackPath(pathname: string, home: '/' | '/portal'): string | null {
  const path = pathname.replace(/\/+$/, '') || '/'
  if (path === home) return null
  if (home === '/') {
    const clientChild = path.match(/^\/clients\/([^/]+)\/.+$/)
    if (clientChild) return `/clients/${clientChild[1]}`
    if (/^\/clients\/[^/]+$/.test(path)) return '/clients'
  }
  return home
}
